var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { ChevronRightIcon } from "@navikt/aksel-icons";
import { Panel } from "../panel/index.js";
import { useRenameCSS } from "../theme/Theme.js";
import { LinkPanelDescription, } from "./LinkPanelDescription.js";
import { LinkPanelTitle } from "./LinkPanelTitle.js";
/**
 * @deprecated Use `LinkCard` instead. Migrations should be straightforward as the API is similar.
 * @see [📝 LinkCard documentation](https://aksel.nav.no/komponenter/core/linkcard)
 *
 * @see [📝 Documentation](https://aksel.nav.no/komponenter/legacy/linkpanel)
 * @see 🏷️ {@link LinkPanelProps}
 * @see [🤖 OverridableComponent](https://aksel.nav.no/grunnleggende/kode/overridablecomponent) support
 *
 */
export const LinkPanelComponent = forwardRef((_a, ref) => {
    var { children, as = "a", border = true, className } = _a, rest = __rest(_a, ["children", "as", "border", "className"]);
    const { cn } = useRenameCSS();
    return (React.createElement(Panel, Object.assign({}, rest, { as: as, border: border, ref: ref, className: cn("navds-link-panel", className) }),
        React.createElement("div", { className: cn("navds-link-panel__content") }, children),
        React.createElement(ChevronRightIcon, { className: cn("navds-link-panel__chevron"), "aria-hidden": true })));
});
const LinkPanel = LinkPanelComponent;
LinkPanel.Title = LinkPanelTitle;
LinkPanel.Description = LinkPanelDescription;
export default LinkPanel;
//# sourceMappingURL=LinkPanel.js.map